{
	"id": 7506,
	"moduleNumber": 6,
	"title": "The Professional Educator and Technology",
	"subtitle": "Apply ethical judgment with technology, maintaining boundaries, transparency, and student welfare.",
	"kgNodeId": "module-6",
	"moduleKind": "standard",
	"moduleKindLabel": "Lesson",
	"summary": "Module 6 is reserved for ethical technology use in education, including digital conduct, data privacy, accessibility, and the educator's professional responsibilities when technology affects student learning and welfare.",
	"estimatedDurationMinutes": 35,
	"activityCount": 2,
	"knowledgeCheck": {
		"included": true,
		"questionCount": 5
	}
}
